import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { InventoryPdgUniqueLocationCombinationLineContainerModel } from '../../../../../models/aggregates/inventory-pdg-unique-location-combination-line';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class InventoryPdgUniqueLocationCombinationLineService extends BaseApiPublicLoginTemplateService<InventoryPdgUniqueLocationCombinationLineContainerModel,InventoryPdgUniqueLocationCombinationLineContainerModel,InventoryPdgUniqueLocationCombinationLineContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-unique-location-combination-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-unique-location-combination-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}